import { PureComponent } from 'react';

/** @namespace Bodypwa/Component/DeliveryIcon/Component */
export class DeliveryIconComponent extends PureComponent {
    render() {
        return (
            <svg
              width="20"
              height="18"
              viewBox="0 0 20 19"
              xmlns="http://www.w3.org/2000/svg"
            >
                { /* eslint-disable-next-line max-len */ }
                <path fillRule="evenodd" clipRule="evenodd" d="M1 0.299805H15.5556V2.52203H17.1656L20 5.71069V15.8554H18.2831C17.8446 16.9307 16.7886 17.6887 15.5556 17.6887C14.3225 17.6887 13.2665 16.9307 12.828 15.8554H7.17203C6.73351 16.9307 5.67749 17.6887 4.44445 17.6887C3.21141 17.6887 2.1554 16.9307 1.71687 15.8554H0V13.6331H1.71867C1.85828 13.292 2.5 11.7998 4.44445 11.7998C5.67751 11.7998 6.73354 12.5577 7.17206 13.6331H12.828C12.951 13.3313 13.1227 13.0545 13.3333 12.8125V2.52203H1V0.299805ZM15.5556 11.7998C15.2863 11.7998 15.0255 11.8359 14.7778 11.9036V4.74425H16.1677L17.7778 6.55558V12.8124C17.238 12.192 16.4426 11.7998 15.5556 11.7998ZM2.94445 14.7442C2.94445 13.9158 3.61602 13.2442 4.44445 13.2442C5.27288 13.2442 5.94445 13.9158 5.94445 14.7442C5.94445 15.5726 5.27288 16.2442 4.44445 16.2442C3.61602 16.2442 2.94445 15.5726 2.94445 14.7442ZM15.5556 13.2442C14.7271 13.2442 14.0556 13.9158 14.0556 14.7442C14.0556 15.5726 14.7271 16.2442 15.5556 16.2442C16.384 16.2442 17.0556 15.5726 17.0556 14.7442C17.0556 13.9158 16.384 13.2442 15.5556 13.2442Z" />
                <path d="M7 9.74982H0V8.24982H7V9.74982Z" />
                <path d="M2 6.24982H9V4.74982H2V6.24982Z" />
            </svg>
        );
    }
}

export default DeliveryIconComponent;
